import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Service } from "@angular/core";
import { TranslateLoader, TranslationObject } from "@ngx-translate/core";
import * as localForage from "localforage";
import { Observable, Subscriber } from "rxjs";

import { Language } from "../../shared/constants/enums";
import { environment } from "../environments/environment";

@Service()
export class CustomTranslateLoader implements TranslateLoader {
  private _httpClient = inject(HttpClient);

  _httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  public getTranslation(lang: string): Observable<TranslationObject> {
    const url = `file/translationsDownload/${lang}`;

    return new Observable((observer) => {
      localForage
        .getItem<TranslationObject>(url)
        .then((cached) => {
          if (cached) {
            observer.next(cached);
            observer.complete();
          } else {
            this._fetchFromApi(url, lang, observer);
          }
        })
        .catch(() => this._fetchFromApi(url, lang, observer));
    });
  }

  private _fetchFromApi(url: string, lang: string, observer: Subscriber<TranslationObject>) {
    this._httpClient.get<TranslationObject>(environment.apiUrl + url, this._httpOptions).subscribe({
      next: (res) => {
        observer.next(res);
        observer.complete();
      },
      error: async () => {
        await this._getTranslationLocally(lang, observer);
      },
    });
  }

  private async _getTranslationLocally(lang: string, observer: Subscriber<TranslationObject>) {
    try {
      const short = lang === Language.English ? "en" : "ar";
      const data = await import(`../../../assets/i18n/${short}.json`);
      observer.next(data.default as TranslationObject);
    } catch {
      // eslint-disable-next-line no-console
      console.error("Local translation file not found for:", lang);
    } finally {
      observer.complete();
    }
  }
}
